import { useMutation } from 'react-query';

import { updateDocument } from '../infrastructure/update-documents';
import { useInvalidateAllDocuments } from './utils/invalidate-all-documents';

export const useUpdateDocumentMutation = () => {
    const invalidateAll = useInvalidateAllDocuments();

    return useMutation({
        mutationFn: updateDocument,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
